import { conformToMask } from 'text-mask-core'

const fixBackspace = (currentValue, previousValue, mask) => {
  if (
    typeof currentValue === 'string' &&
    typeof previousValue === 'string' &&
    previousValue.length - currentValue.length === 1 &&
    previousValue.substr(0, currentValue.length) === currentValue
  ) {
    const index = previousValue.length - 1
    if (previousValue.substr(index, 1) === mask[index]) {
      return currentValue.substr(0, index - 1)
    }
  }
  return currentValue
}

const truncate = email => {
  const allowedEmailSize = 35
  if (email.length > allowedEmailSize) {
    const fields = email.split('@')
    const emailSize = allowedEmailSize - fields[1].length - 4
    const trunc = fields[0].slice(0, emailSize)
    return trunc.concat('...@', fields[1])
  }
  return email
}

export default (currentValue, previousValue, mask) => {
  if (!currentValue) return null
  let current = typeof currentValue === 'number' ? String(currentValue) : currentValue
  const previous = typeof previousValue === 'number' ? String(previousValue) : previousValue
  if (typeof previous === 'string') {
    current = fixBackspace(current, previous, mask)
  }
  return conformToMask(current, mask, { guide: false }).conformedValue
}

export { fixBackspace, truncate }
